if (!customElements.get('expandable-key-features')) {
  class ExpandableKeyFeatures extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        tabs: this.querySelectorAll('.expandable-key-features__tab'),
        toggleButtons: this.querySelectorAll('.expandable-key-features__tab'),
        container: this.querySelector('.expandable-key-features__container'),
        headings: this.querySelector('.expandable-key-features ul'),
      }

      this.setupEventListeners();
    }

    setupEventListeners() {
      const tabs = Array.from(this.elements.toggleButtons)

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          if (tab.classList.contains('active')) {
            tab.classList.remove('active');
            return;
          }

          const filteredTabs = tabs.filter(t => t !== tab);

          filteredTabs.forEach(t => t.classList.remove('active'));

          tab.classList.add('active');

          if (window.matchMedia('(min-width: 750px)').matches) {
            const tabHeight = tab.querySelector('.expandable-key-features__content__wrapper').scrollHeight;
            const headingsHeight = this.elements.headings.scrollHeight;
            this.elements.container.style.minHeight = `${tabHeight + headingsHeight + 105}px`;
          }
        });
      });
    }

    setMinHeight() {
      if (window.matchMedia('(min-width: 750px)').matches) {
        const activeTab = this.querySelector('.expandable-key-features__tab.active');
        if (activeTab) {
          const tabHeight = activeTab.querySelector('.expandable-key-features__content__wrapper').scrollHeight;
          const headingsHeight = this.elements.headings.scrollHeight;
          this.elements.container.style.minHeight = `${tabHeight + headingsHeight + 105}px`;
        }
      } else {
        this.elements.container.style.minHeight = 'auto';
      }
    }

    connectedCallback() {
      this.setMinHeight();
      window.addEventListener('resize', () => this.setMinHeight());
    }
  }

  customElements.define('expandable-key-features', ExpandableKeyFeatures);
}
